import { Icon } from '@zenid/web';
import type { MembershipSchema } from '@zenid/mypage-api';
import { css } from '../../../../../styled-system/css';
import { flex } from '../../../../../styled-system/patterns';
import { PastOrganizations } from './PastOrganizations';
import { CurrentOrganizations } from './CurrentOrganizations/CurrentOrganizations';
import { partitionMemberships } from './partition-memberships';

type Props = { memberships: MembershipSchema[] };

export function Organizations({ memberships }: Props) {
  const { currentMemberships, pastMemberships } = partitionMemberships(memberships);
  return (
    <div className={flex({ minWidth: '343px', flexDirection: 'column', sm: { maxWidth: '720px' } })}>
      <div
        className={flex({
          flexDirection: 'row',
          alignItems: 'center',
          gap: '{spacing.4}',
          marginBottom: '{spacing.20}',
        })}
      >
        <Icon name="badge" color="colors.text.main" size="m" />
        <h2 className={css({ textStyle: 'headding.s', sm: { textStyle: 'headding.l' } })}>所属情報</h2>
      </div>
      <CurrentOrganizations memberships={currentMemberships} />
      <PastOrganizations memberships={pastMemberships} />
    </div>
  );
}
